import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { GroupAddModalComponent } from './group-add.component';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { ModalsModule } from '../../../widgets/entry-components/modal/modals.module';
import { TranslateModule } from '../../../shared/translate/translate.module';

@NgModule({
  declarations: [GroupAddModalComponent],
  imports: [
    CommonModule, IonicModule, ModalsModule, TranslateModule, FormsModule, ReactiveFormsModule
  ],
  entryComponents: [GroupAddModalComponent],
  exports: [GroupAddModalComponent]
})
export class GroupAddModalModule { }
